


























import { defineComponent } from '@nuxtjs/composition-api';
import BaseButton from '@shared/components/@atoms/BaseButton/BaseButton.vue';
import BaseIcon from '@shared/components/@atoms/BaseIcon/BaseIcon.vue';
import BaseLink from '@shared/components/@atoms/BaseLink/BaseLink.vue';
export default defineComponent({
  name: 'BaseMenuItem',
  components: {
    BaseIcon,
    BaseLink,
    BaseButton,
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    icon: {
      type: [String, Array],
      default: 'chevron_right',
    },
    count: {
      type: [String, Number],
      default: '',
    },
    link: {
      type: [String, Object],
      default: null,
    },
  },
  computed: {
    bind() {
      const bind = {};
      if (this.link) {
        // @ts-ignore migrated from ui-library
        bind.link = this.link;
      } else {
        // @ts-ignore migrated from ui-library
        bind.class = 'sf-button--pure';
      }
      return bind;
    },
    componentIs(): any {
      // @ts-ignore migrated from ui-library
      return this.link ? 'BaseLink' : 'BaseButton';
    },
  },
});
